import script from "./_DiscoveryDescriptionSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./_DiscoveryDescriptionSingle.vue?vue&type=script&setup=true&lang=js"

import "./_DiscoveryDescriptionSingle.vue?vue&type=style&index=0&id=2ee20373&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ee20373"]])

export default __exports__